import React, { useState } from "react";
import styled from "styled-components";
import "swiper/components/pagination/pagination.min.css";
// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import order2 from "../assets/order2.svg";
import data from "../data/rushdata.json";

// install Swiper modules
SwiperCore.use([Pagination, Autoplay]);

const WhyRush = () => {
  const [hover, sethover] = useState(2);
  return (
    <Wrapper>
      <div className="section-center text-center why_rush">
        <div className="rush__top">
          <h1>Why Rush</h1>
          <p>
            Rush helps individuals move items from where they currently to where
            you need them to be, all in real-time.
          </p>
        </div>

        <div className="rush__bottom">
          <div className="why_rush_for_mobile">
            <Swiper
              className="mySwiper"
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
            >
              {data.buisnessData.map(({ id, icon, rushH1, rushP }) => (
                <SwiperSlide key={id}>
                  <div className="single__rush">
                    <div className="rush__icon">
                      <img src={icon} alt="" />
                    </div>
                    <div className="rush__des">
                      <h1 className="rushH1">{rushH1}</h1>
                      <p className="rushp">{rushP}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="why_rush_for_desktop">
            {data.rushData.map(({ id, icon, rushH1, rushP }) => (
              <div
                key={id}
                className={
                  hover === id ? "single__rush active" : "single__rush"
                }
                onMouseOver={() => sethover(id)}
              >
                <div className="rush__icon">
                  <img src={icon} alt="" />
                </div>
                <div className="rush__des">
                  <h1 className="rushH1">{rushH1}</h1>
                  <p className="rushp">{rushP}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {data.indiImg.map(({ id, indiImage }) => (
          <div className="indi__images" key={id}>
            <img src={indiImage} alt="indiImage" />
          </div>
        ))}

        <div className="order__rush">
          <div className="order__rush_left">
            <h1>Order for pickups and deliveries.</h1>
            <p>
              Save time and cost on your pickups and deliveries. Whatever you
              need to send or pick up, Wecanrush has you covered.
            </p>
          </div>
          <div className="order">
            {data.orderImg.map(({ id, orderImage }) => (
              <div className="order__rush_right" id={`order_id${id}`} key={id}>
                <img src={orderImage} alt="orderImage" />
              </div>
            ))}

            {data.orderImgSec.map(({ id, orderImage }) => (
              <div
                className="order__rush_right_sec"
                id={`order_ids ${id}`}
                key={id}
              >
                <img src={orderImage} alt="orderImage" />
              </div>
            ))}
            <div className="order__rush_right_mobile">
              <img src={order2} alt="orderImagesss" />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  @media screen and (max-width: 768px) {
    .why_rush {
      padding: 0px 12px !important;
    }
    .rush__top {
      padding-top: 76px;
      h1 {
        font-size: 36px !important;
      }
      p {
        font-size: 14px !important ;
        line-height: 19px !important;
        text-align: center !important;
        width: 363px !important;
      }
    }
    .single__rush {
      width: 440px !important;
      margin: 0 20px;
    }
    .indi__images {
      height: 316.07px !important;

      img {
        width: 500px !important;
      }
    }

    .order__rush {
      display: flex !important;
      height: 660px !important;
    }
    .order__rush_left {
      margin-right: 150px;
      margin-top: 110px;
      text-align: center;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 423px;
      margin: auto;
      margin-left: 200px;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 40px;
        line-height: 46px;
        align-items: center;
        color: #6300ff;
        text-align: center !important;
      }
      p {
        font-family: "Manrope";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #545777;
        text-align: center !important;
        margin-top: 25px;
        -webkit-letter-spacing: 0.8px;
        -moz-letter-spacing: 0.8px;
        -ms-letter-spacing: 0.8px;
        letter-spacing: 0.8px;
      }
    }
    .order {
      /* position: relative; */
      position: absolute !important;
      right: 25px !important;
      display: flex;
      justify-content: center;
      align-content: center;
      /* div#order_id2 {
        display: none;
      } */

      .order__rush_right {
        display: none !important;
      }
      .order__rush_right_sec {
        display: block !important;
        width: 360px !important;
        height: 417px !important;
        img {
          width: 100% !important;
          height: 100% !important;
        }
      }
      .order__rush_right_mobile {
        display: none !important;
        width: 360px !important;
        height: 385.71px !important;
        img {
          width: 100% !important;
        }
      }
    }

    .why_rush_for_desktop {
      display: none !important;
    }
    .why_rush_for_mobile {
      display: block !important;
      width: 100%;
    }
    .mySwiper {
      width: 516px;
      padding: 78px 0;
    }
    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px;
      width: 300px;
    }
    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px;
      width: 300px;
    }
  }

  @media screen and (max-width: 440px) {
    .order__rush_left {
      text-align: center;
      justify-content: center;
      width: 100% !important;
      margin: 0 auto !important;

      margin-right: 150px;
      margin-top: 110px;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      /* width: 423px; */
      margin: auto;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 40px;
        line-height: 46px;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #6300ff;
        text-align: left !important;
        width: 100% !important;
      }
      p {
        font-family: "Manrope";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #545777;
        text-align: left !important;
        width: 100% !important;
        margin-top: 25px;
        -webkit-letter-spacing: 0.8px;
        -moz-letter-spacing: 0.8px;
        -ms-letter-spacing: 0.8px;
        letter-spacing: 0.8px;
      }
    }

    .order__rush_right {
      display: none;
    }

    .indi__images {
      height: 316.07px !important;

      img {
        width: 100% !important;
      }
    }
    .mySwiper {
      width: 387px !important;
      padding: 78px 0;
    }
    .single__rush {
      width: 387px !important;
      border-radius: 15px !important;
      box-shadow: 0px 0px 50px 0px #e7f5ff !important;
      box-sizing: border-box !important;
      padding: 15px !important;
      margin-left: 8px !important;
      text-align: left;
      width: 366px !important;
      height: 329px;
    }

    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px;
      width: 340px;
    }

    .rush__icon {
      margin-top: 40px;
    }

    .swiper-container-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      max-width: 387px !important;
      display: flex;
      justify-content: center;
    }
    .rush__bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      margin-top: 110px;
      margin-bottom: 220px;
    }
    .order__rush_right_sec {
      margin-top: 90px;
    }
  }

  .why_rush_for_mobile {
    display: none;
  }
  .why_rush_for_desktop {
    display: flex;
    flex-direction: row;
    align-items: space-between;
    width: 100%;
    margin: auto;
  }

  .rush__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    margin-top: 110px;
    margin-bottom: 180px;
  }

  .rush__icon {
    padding-left: 5px;
  }

  .rush__top {
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 48px;
      line-height: 56px;
      text-align: center;
      color: #6300ff;
      width: 243px;
      height: 61px;
      margin: auto;
    }

    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #6d7d93;
      width: 950px;
      margin: auto;
      height: 54px;
      letter-spacing: 1px;
      margin-top: 40px;
    }
  }

  .rush__des {
    margin-top: 52.87px;
    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 24px;
      line-height: 29px;
      color: #2a60e4;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      letter-spacing: 1px;
      margin-top: 12px;
    }
  }
  .indi__images {
    height: 860px;
    margin: 0;
    img {
      width: 887px;
    }
  }
  .order__rush {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: space-around;
    margin-top: 150px;
    height: 400px;
    position: relative;
    margin-bottom: 230px;
  }

  .order__rush_right {
    width: 750px;
    height: 607px;
  }

  .order__rush_right_sec {
    display: none;
  }

  div#order_id1 {
    position: absolute;
  }
  div#order_id1 img {
    width: 523px;
    height: 607px;
  }

  .order__rush_right_mobile {
    position: absolute;
    top: -375px;
    left: -30px;
  }

  .order {
    position: absolute;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    right: 300px;
    top: 235px;
  }

  .order__rush_left {
    margin-top: 110px;
    position: absolute;
    left: 0;
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 40px;
      line-height: 46px;
      display: flex;
      align-items: center;
      color: #6300ff;
      width: 420px;
      height: 92px;
      text-align: left;
    }

    p {
      font-family: "Manrope";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #545777;
      text-align: left;
      width: 460px;
      height: 100px;
      margin-top: 25px;
      letter-spacing: 0.8px;
    }
  }

  .single__rush {
    width: 340px;
    border-radius: 15px !important;
    /* box-shadow: 0px 0px 50px 0px #e7f5ff !important; */
    box-sizing: border-box !important;
    padding: 15px !important;
    margin-right: 50px;
    text-align: left;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    cursor: pointer;
    transition: 0.3s;
  }
  .single__rush.active {
    width: 340px;
    border-radius: 15px !important;
    box-shadow: 0px 0px 50px 0px #e7f5ff !important;
    box-sizing: border-box !important;
    padding: 15px !important;
    margin-right: 50px;
    text-align: left;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    cursor: pointer;
    transition: 0.3s;
  }
  .single__rush:hover {
    transform: scale(1.1);
  }

  .swiper-container.swiper-container-initialized.swiper-container-horizontal.swiper-container-pointer-events.mySwiper {
    padding-bottom: 90px;
  }
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    width: 500px !important;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
    width: 10px;
    height: 5px;
    border-radius: 5px;
  }
`;

export default WhyRush;
